import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { HeadingSize } from './heading.types';

/** @slot - Text content */
@Component({
  tag: 'wb-heading',
  styleUrl: 'heading.scss',
  shadow: true,
})
export class HeadingComponent implements ComponentInterface {
  /** Size of the font */
  @Prop({ reflect: true })
  public size: HeadingSize = 'm';

  /** Sets text overflow ellipsis */
  @Prop({ reflect: true })
  public ellipsis: boolean = false;

  /** Chinese font variants - only available in combination with `size` xl, l and m */
  @Prop({ reflect: true })
  public chinese: boolean = false;

  /** Line Height increased variant - recommended for languages with special characters that needs a higher value for line-height. For example for Arabic, Slovak, Thai, etc. Only available in combination with `size` xl, l and m  */
  @Prop({ reflect: true })
  public lineHeightIncreased: boolean = false;

  /** (Semantic) HTML tag to wrap around text content */
  @Prop({ reflect: true })
  public tag: string = 'div';

  public render(): JSX.Element {
    const TagName = this.tag;

    return (
      <Host class="wb-heading">
        <TagName class="tag">
          <slot />
        </TagName>
      </Host>
    );
  }
}
